import React from 'react';
import {
    Bar,
    Title,
    BackIcon,
    RightIcon,
} from './Topbar.style';

const Topbar = ({
    title,
    rightIcon = '',
    shadow = false,
    showLeftIcon = true,
    goBack,
    isBlack
}) => {

    return (
        <Bar isBlack={isBlack} id='top-bar' shadow={shadow ? 'show' : 'hide'}>
            {showLeftIcon && <BackIcon onClick={() => goBack()} />}
            <Title>
                {title}
            </Title>
            {rightIcon &&
                <RightIcon>
                    {rightIcon}
                </RightIcon>
            }
        </Bar>
    );
}

export default Topbar;